<script setup lang="ts">
import AccountListRow from "@/components/TenkoAssociations/AccountListRow.vue";
import ResizableList from '@/components/ResizableList.vue';
import tenkoAssociationType from "@/types/responses/getIttenkoAssociation"
import { HEADERS } from "@/services/consts/tenko_associations";
import accountType from "@/types/account";
import i18n from '@/lang/i18n';

const emits = defineEmits(['openUpdateModal', 'openDeleteModal']);
const props = defineProps<{
  tenkoAssociations: tenkoAssociationType[];
  accounts: accountType[];
  isSearched: boolean;
  isLoading: boolean;
  isUpdateAuthority: boolean;
  isDeleteAuthority: boolean;
}>();

function openUpdateModal(account: accountType, employeeCd: string, isRegistered: boolean) {
  return emits('openUpdateModal', account, employeeCd, isRegistered)
}

function openDeleteModal(tenkoAssociation: tenkoAssociationType) {
  return emits('openDeleteModal', tenkoAssociation)
}
</script>
<template>
  <div class="tenko-associations-list">
    <template v-if="!props.isSearched">
      <div class="list-loading">
        <label>
          {{ i18n.global.t('pages.common.list.runFilter') }}
        </label>
      </div>
    </template>
    <template v-else-if="props.isLoading">
      <div class="list-loading">
        <label>
          {{ i18n.global.t('pages.common.list.reading') }}
        </label>
      </div>
    </template>
    <ResizableList
      scrollAreaSelector=".list"
    >
    <div
      class="list list-scrollbar"
    >
      <v-table>
        <thead>
          <tr class="table-header-row">
            <th
              v-for="header in HEADERS" :key="header"
              class="table-header column-space"
            >
              <div class="d-flex align-items-center">
                <span>{{ header }}</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="props.accounts.length">
            <tr v-for="account in props.accounts" :key="account.id">
              <AccountListRow
                :account="account"
                :tenkoAssociations="props.tenkoAssociations"
                :isUpdateAuthority="props.isUpdateAuthority"
                :isDeleteAuthority="props.isDeleteAuthority"
                @openUpdateModal="openUpdateModal"
                @openDeleteModal="openDeleteModal"
              />
            </tr>
          </template>
          <template v-else-if="!props.accounts.length && props.isSearched && !props.isLoading">
            <tr>
              <td colspan="9">
                {{ i18n.global.t('pages.common.list.noData') }}
              </td>
            </tr>
          </template>
        </tbody>
      </v-table>
    </div>
    </ResizableList>
  </div>
</template>
<style>
.tenko-associations-list .list table {
  position: absolute;
}
.tenko-associations-list .list td {
  word-break: keep-all;
}
.tenko-associations-list .list th {
  min-width: 7em;
  position: -webkit-sticky;
  position: sticky;
  background-color: white;
  top: 0;
  z-index: 1;
}
</style>
<style scoped>
.tenko-associations-list {
  position: relative;
}
.tenko-associations-list .list {
  position: relative;
  min-width: 58vw;
  height: var(--resizable-height, var(--list-default-height));
  overflow: auto;
}
.tenko-associations-list table th {
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
}
.tenko-associations-list .list .id-column {
  min-width: 2em;
}
.tenko-associations-list .list .updated-at-column {
  min-width: 10em;
}
.checkbox-in-grid {
  padding: 1vm;
  height: inherit !important;
  display: inline-grid !important;
}
.list-loading {
  position: absolute;
  min-width: 58vw;
  height: 100%;
  overflow: auto;
  z-index: 1000;
  background-color: rgba(80,80,80,0.5);
  right: 0;
  left: 0;
}
.list-loading>label {
  font-weight: bold;
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
.column-space {
  white-space: nowrap;
}
.edit-icon:hover {
  cursor: pointer;
  opacity: 0.5;
}
.tenko-associations-list .sort-icon:hover {
  cursor: pointer;
  opacity: 0.5;
}
</style>
